import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "Notify-banner-overlay"
}
const _hoisted_2 = { class: "Notify-banner-container" }
const _hoisted_3 = ["href"]
const _hoisted_4 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.isVisible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("button", {
            class: _normalizeClass(["Notify-close-overlay", {'dark-close':_ctx.blackIcon}]),
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeBannerPopup && _ctx.closeBannerPopup(...args)))
          }, "×", 2 /* CLASS */),
          _createElementVNode("a", {
            href: _ctx.redirectUrl,
            target: "_blank",
            rel: "noopener noreferrer"
          }, [
            _createElementVNode("img", {
              src: _ctx.banner,
              alt: "Event Banner",
              class: "Notify-banner-image",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeBannerPopup && _ctx.closeBannerPopup(...args)))
            }, null, 8 /* PROPS */, _hoisted_4)
          ], 8 /* PROPS */, _hoisted_3)
        ])
      ]))
    : _createCommentVNode("v-if", true)
}